import { useEffect, useState } from "react";
import { useListCustomers, ListCustomerOptions } from "@/lib/api/customer";
import { Separator } from "@/components/ui/separator";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CustomerNotesSection } from "@/section/risk/RiskManagementFullDashboard/CustomerNotesSection";
import { CustomerTodosSection } from "@/section/risk/RiskManagementFullDashboard/CustomerTodosSection";
import { DbUserWithPackages } from "@/lib/api/users";

interface CustomerActivitiesSectionProps {
    customerId?: string;
    traderId?: string;
    showCustomerNames?: boolean;
    hideTodos?: boolean;
    hideNotes?: boolean;
    customerListFilter?: ListCustomerOptions;
    activity_type?: "risk" | "sales_notes";
    assignableUsersFilter?: (users: DbUserWithPackages[]) => DbUserWithPackages[];
}

export function CustomerActivitiesSection(props: CustomerActivitiesSectionProps) {
    const { showCustomerNames, hideTodos, hideNotes } = props;
    const [customerId, setCustomerId] = useState(props.customerId);
    const [traderId, setTraderId] = useState(props.traderId);

    useEffect(() => {
        setCustomerId(props.customerId);
        setTraderId(props.traderId);
    }, [props.customerId, props.traderId]);

    // Always show the split view layout like the original
    return (
        <div className="flex flex-col md:grid md:grid-cols-[1fr,auto,1fr] gap-6 row-span-2">
            {!hideTodos && (
                <>
                    <ScrollArea className="max-h-[83vh]">
                        <CustomerTodosSection 
                            customerId={customerId}
                            traderId={traderId}
                            showCustomerName={showCustomerNames}
                            allowCustomerSelection={!customerId}
                            customerListFilter={props.customerListFilter}
                            activity_type={props.activity_type}
                            assignableUsersFilter={props.assignableUsersFilter}
                        />
                    </ScrollArea>
                    <div><Separator orientation="vertical" /></div>
                </>
            )}
            {!hideNotes && (
                <ScrollArea className="max-h-[80vh]">
                    <CustomerNotesSection 
                        customerId={customerId}
                        showCustomerName={showCustomerNames}
                        customerListFilter={props.customerListFilter}
                        activity_type={props.activity_type}
                    />
                </ScrollArea>
            )}
        </div>
    );
}
